import ApiService from "./api";

const Capacity = {
    post(body, params = null) {
        return ApiService.post(`capacity`, body, {params: params});
    },
}

export default Capacity;
